import api from '../config/axiosConfig';

export const RequisitoService = {
    fetchRequisitos: async (token) => {
        try {
            const response = await api.get('/ventas/requisitos', {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data || [];
        } catch (error) {
            console.error('Error en RequisitoService.fetchRequisitos:', error);
            throw error;
        }
    },
};
